import type { Commission } from '@/types/entities'

// Commissions are pounds the artist earns per sale, added to the base price
// (lib/product.js getPrice: (base + commission) × (1 + vat)). The commissions page used to read
// and write a `markup` percentage the API has never had, so every size showed 0% and a change
// was sent with none of the fields the API reads — matching no row, while reporting success.
export const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })

// The API refuses more (lib/commission-update.js).
export const MAX_COMMISSION = 1000

/** What the artist earns on this size: their own figure when set, otherwise the default. */
export function effectiveCommission(c: Commission): number {
  return Number(c.isCustom ? c.commission : c.defaultCommission) || 0
}

/** What the customer is charged for this size, or null when it has no base price. */
export function customerPrice(c: Commission, commission = effectiveCommission(c)): number | null {
  if (c.basePrice == null) return null
  return Math.round((Number(c.basePrice) + commission) * (1 + Number(c.vat || 0)) * 100) / 100
}
